import { Controller } from "@hotwired/stimulus";
import Rails from 'rails-ujs';

export default class extends Controller {
  static targets = ['category'];

  connect() {
    this.selectElm.addEventListener('change', () => {
      this.post();
    });
  }

  get selectElm() {
    return this.element.querySelector('select');
  }

  get url() {
    return this.element.dataset.url;
  }

  get rating() {
    return this.selectElm.value;
  }

  get categoryId() {
    return this.categoryTarget.value;
  }

  get data() {
    return `review_rating[review_rating_category_id]=${this.categoryId}&review_rating[rating]=${this.rating}`;
  }

  post() {
    if (this.url.length == 0) return;

    Rails.ajax({
      type: 'POST',
      dataType: 'script',
      data: this.data,
      url: this.url
    });
  }
}
